import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from '../../ui';
import Loader from '../Loader';
import warningImage from '../../../assets/common/warning.png';
import mailImage from '../../../assets/common/mail.png';
import {
  clean,
  setPaymentValue,
  setStepInnerPage
} from '../../../actions';

class PaymentMessage extends Component {

  constructor(props) {
    super(props);
    this.tryAgain = this.tryAgain.bind(this);
    this.message = this.message.bind(this);
  }

  tryAgain() {
    const {
      paymentType,
      resetPurchaseResult,
      openSiemprePagoModal
    } = this.props;

    resetPurchaseResult();
    switch (paymentType) {
      case 'credit':
        openSiemprePagoModal();
        break;
    };
  }

  message(result) {
    const {
      restart,
      reintentar,
      errorMessage,
      backToCheckoutPage,
      newPolicy
    } = this.props;

    const image = result ? mailImage : warningImage;
    const text1 = result ? `La compra fue realizada exitosamente!` : `Tuvimos un inconveniente con la compra.`;
    const text2 = result ? `Se te ha enviado un mail con los detalles de tu compra.` : `${errorMessage}.`;
    const textPolicy = newPolicy ? `Número de Póliza: ${newPolicy.Number}` : '';

    return (
      <div className="Message-container">
        <div className="Message-container-image">
          <img className="Message-image" src={image} alt="message" />
        </div>
        <p className="Message-text"> {text1} <br/> {text2} </p>
        <p className="Message-text"> {textPolicy} </p>
        <div className="Message-button-container">
          <Button onClick={() => {restart()}}> Volver a cotizar </Button>
          {!result &&
            <Button plain onClick={backToCheckoutPage} className="Message-link">
              Volver a medios de pago
            </Button>
          }
        </div>
      </div>
    );
  }

  render() {
    const { loading, purchaseResult } = this.props;
    return loading ? <Loader /> : this.message(purchaseResult);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    paymentType: state.payment.paymentType,
    errorMessage: state.payment.errorMessage,
    purchaseResult: state.payment.purchaseResult,
    newPolicy: state.payment.newPolicy
  };
};

const mapDispatchToProps = dispatch => {
  return {
    restart: () => {
      dispatch(clean());
    },
    resetPurchaseResult: () => {
      dispatch(setPaymentValue('purchaseResult', null));
      dispatch(setPaymentValue('newPolicy', null));
    },
    openSiemprePagoModal: () => {
      dispatch(setPaymentValue('openSiemprePago', true));
    },
    backToCheckoutPage: () => {
      dispatch(setStepInnerPage('checkout'));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMessage);